module.exports = __webpack_public_path__ + "assets/img/Concept_bgimg.98432a4d.png";